import { render, staticRenderFns } from "./courseLearningRate.vue?vue&type=template&id=48965e18&scoped=true"
import script from "./courseLearningRate.vue?vue&type=script&lang=js"
export * from "./courseLearningRate.vue?vue&type=script&lang=js"
import style0 from "./courseLearningRate.vue?vue&type=style&index=0&id=48965e18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48965e18",
  null
  
)

export default component.exports